module.exports = __webpack_public_path__ + "static/media/feedback-icon.10add621.svg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/assets/images/feedback-icon.svg
// module id = 1781
// module chunks = 27